import React, { useReducer } from 'react';
import { useHistory } from 'react-router-dom';
import { generatePath } from "react-router";
import { SwiperSlide } from 'swiper/react/swiper-react.js';
import { v4 as uuid } from 'uuid';

// redux
import { connect } from 'react-redux';

// @material-ui/core
import { Hidden, makeStyles, useMediaQuery } from '@material-ui/core';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import Icon from '@material-ui/core/Icon';

// shared core components
import SlickCarousel from '../SlickCarousel/SlickCarousel';
import TitleLink from '../TitleLink/TitleLink';

// Path
import {PROGRAMA} from '../../../routes/paths';

//MIXPANEL - SERVICES
import { Mixpanel } from '../Mixpanel/mixpanel';
import { ProgramService, MIXPANEL_EVENT, MarketPlaceService } from '@sdk-point/talisis';

// Utils
import { getSourceBySourceAndCompany } from '../../../design-system/utils/source';
import { log } from '../../../shared/utils/console.js'

//REDUX
import ProgramsProvider from './context/ProgramsProvider';
import programsReducer, { initialPrograms, types } from './context/ProgramsReducer';

// DS
import LandSearchProgramCard from '../../../design-system/components/Cards/LandSearchProgramCard/LandSearchProgramCard';

// styles
import useStyles from '../../../assets/styles/jss/components/programCarouselStyle';

import * as paths from '../../../routes/paths'

import Button from '@material-ui/core/Button';
import { eventData, eventTracker } from '../../../shared/components/EventTracker/EventTracker';


const marketService = new MarketPlaceService(process.env.REACT_APP_ENV, process.env.REACT_APP_X_API_KEY);

const ProgramCarousel = (props) => {
    const { title, type, user, isDetail, ou, disableLink = false, className, titleVariant = 'h4', autoResponsive = true, filterParams = null, showAllPath} = props;
    const classes = useStyles();
    const history = useHistory();
    const isResponsive = useMediaQuery(theme => theme.breakpoints.down('xs'));
    const abortData = new AbortController();
    const [hiddeCarouselByEmpty, setHiddeCarouselByEmpty] = React.useState(false);
    const [dynamicTitleLink, setDynamicTitleLink] = React.useState(null);
    const [lengthCarousel, setLengthCarousel] = React.useState(12);
    const [loading, setLoading] = React.useState(false);
    const [programsState, dispatch] = useReducer(programsReducer, initialPrograms);
    const { programs }  = programsState;


    const setTMixpanelTrack = (e, courseId, courseName, companyId, source_name, path) => {
        e.stopPropagation();
    }
   
    const getData = async () => {
        try {
            let programsData = [];
            let programs = null;
            setLoading(true);
            if(type === "bachillerato"){
                programs = await marketService.searchDataV2(
                    {
                        "search":"",
                        personId: user.person_id,
                        "academies":[],
                        "educativeOffer":["BA"],
                        "sources":[1],
                        "modalities":[],
                        "companies":[ou]
                    },  null, abortData);

                const sliceData = programs.data[0].filter(it => it.hasOwnProperty('id')).slice(0, 20);

                if(sliceData.length > 0){
                    programsData = sliceData;
                }
            }else if(type === "licenciatura"){
                programs = await marketService.searchDataV2(
                    {
                        "search":"",
                        personId: user.person_id,
                        "academies":[],
                        "educativeOffer":["LI"],
                        "sources":[1],
                        "modalities":[],
                        "companies":[ou]
                    },  null, abortData);
                const sliceData = programs.data[0].filter(it => it.hasOwnProperty('id')).slice(0, 20);

                if(sliceData.length > 0){
                    programsData = sliceData;
                }
            }else if(type === "maestria"){
                programs = await marketService.searchDataV2(
                    {
                        "search":"",
                        personId: user.person_id,
                        "academies":[],
                        "educativeOffer":["MA"],
                        "sources":[1],
                        "modalities":[],
                        "companies":[ou]
                    },  null, abortData);
                const sliceData = programs.data[0].filter(it => it.hasOwnProperty('id')).slice(0, 20);

                if(sliceData.length > 0){
                    programsData = sliceData;
                }
            }else if(filterParams){
                const params = {
                    "search":"",
                    personId: user.person_id,
                    "academies":[],
                    "educativeOffer":[],
                    "sources":[1],
                    "modalities":[],
                    "companies":[]
                }

                const filterParamsBody = Object.assign({}, params, filterParams);
                programs = await marketService.searchDataV2(
                    filterParamsBody,  null, abortData);
                const sliceData = programs.data[0].filter(it => it.hasOwnProperty('id')).slice(0, 20);

                if(sliceData.length > 0){
                    programsData = sliceData;
                }
            }
            setLoading(false);
            //log(programsData);
            return programsData;
        } catch (e) {
            log(e.message);
        }
    };

    const handleClickProgramCard = (param) => {
        history.push(generatePath(PROGRAMA, {id: param.id}));
    };

    React.useEffect(() => {
        let isCanceled = true;
        getData().then((data)=>{
            if(isCanceled){
                setLengthCarousel(data?.length);
                if(data?.length == 0){
                    setHiddeCarouselByEmpty(true);
                }else{
                    setHiddeCarouselByEmpty(false);
                }
                dispatch({ type: types.addPrograms, payload: data});
                setLoading(false);  
            }
        }).catch((err) => {
          log(`Failed: ${err}`);
        });

        return () => (isCanceled = false);
    }, []);

    const handleClickInTitle = (e) =>{
        e.preventDefault();

        if(showAllPath){
            history.push(showAllPath);
        }
    }

    const goTo = () => {
        const eventData = {};
        eventData['source'] = 'landing';
        eventTracker('ver_membresías', eventData, ['mixpanel', 'google']);
        history.push(paths.MEMBRESIAS);
    };

    return (
        <ProgramsProvider>
            { !hiddeCarouselByEmpty && 
                <Box className={className}>
                    <Hidden id="desktop" xsDown={autoResponsive}>
                        <Box className={classes.root_carousel}>
                            { !loading && !hiddeCarouselByEmpty && <Box position="relative" className={classes.hover_carousel}>
                                {
                                    title &&
                                    <Typography className={`${classes.title} program_carousel_title title-link`} variant={titleVariant}>
                                        {disableLink ? title : <TitleLink textPrimary={dynamicTitleLink == null ? title: dynamicTitleLink} textSecondary="Ver todos" onClick={(e) => handleClickInTitle(e)} hideSubtitleResponsive={true}/> }
                                    </Typography>
                                }
                                <SlickCarousel isDetail={isDetail} length={lengthCarousel} typeCard="normal" slidesToShow={1} slidesToScroll={1} variableWidth slideMargin="0px">
                                    {
                                        programs.map((programItem, index) => {
                                                return (
                                                    <SwiperSlide className={classes.card} key={uuid()} style={{ zIndex: programs.length - index }}>
                                                        <Box onClick={(e) => setTMixpanelTrack(e, programItem?.id, programItem?.name, programItem?.company_id, programItem?.source_name, '')} style={{ textDecoration: "none" }}>
                                                            <LandSearchProgramCard
                                                                onClickMixPanelCard={null}
                                                                userId={user?.person_id}
                                                                programId={programItem.id}
                                                                onClick={handleClickProgramCard}
                                                                backgroundImage={isResponsive ? programItem.images["itemlist"] : programItem.images["default"]}
                                                                membershipIdList={programItem.membresia_id}
                                                                levelId={programItem.level_id}
                                                                sourceId={getSourceBySourceAndCompany(programItem.source, programItem.company)}
                                                                name={programItem?.name}
                                                                content={{
                                                                    price: {
                                                                        number: programItem.price,
                                                                        listNumber: programItem.price,
                                                                    },
                                                                    showLabel: programItem.showLabel,
                                                                    showPrice: programItem.showPrice,
                                                                    labelToShow: programItem.labelToShow,
                                                                    typeLabel: programItem.typeLabel,
                                                                }}
                                                            />
                                                        </Box>
                                                    </SwiperSlide>
                                                )
                                        })
                                    }  
                                </SlickCarousel>
                                
                            </Box>}

                            <Hidden smUp>
                                <Box textAlign='center'>
                                    <Button color='primary' endIcon={<Icon className='ri-arrow-right-s-line' style={{fontSize: '24px !important'}} />} onClick={handleClickInTitle}>Ver todos</Button>
                                </Box>
                            </Hidden>


                        </Box>
                    </Hidden>
                    <Hidden id="mobil" smUp={true} xsDown={!autoResponsive}>
                        <Box mb={5}>
                            <Box mb={4} display="flex" justifyContent="space-between" alignItems="center">
                                <Typography variant="h2">{title}</Typography>
                                <Typography variant="subtitle1" component="span" className="text-dark-black-100">{programs.length} Programas</Typography>
                            </Box>
                            <Box display="flex" gridGap="16px" flexDirection="column" alignItems="center">
                                {
                                    programs.map((programItem, index) => (
                                        <LandSearchProgramCard
                                            key={uuid()}
                                            onClickMixPanelCard={null}
                                            userId={user?.person_id}
                                            programId={programItem.id}
                                            onClick={handleClickProgramCard}
                                            backgroundImage={isResponsive ? programItem.images["itemlist"] : programItem.images["default"]}
                                            membershipIdList={programItem.membresia_id}
                                            levelId={programItem.level_id}
                                            sourceId={getSourceBySourceAndCompany(programItem.source, programItem.company)}
                                            name={programItem?.name}
                                            content={{
                                                price: {
                                                    number: programItem.price,
                                                    listNumber: programItem.price,
                                                },
                                                showLabel: programItem.showLabel,
                                                showPrice: programItem.showPrice,
                                                labelToShow: programItem.labelToShow,
                                                typeLabel: programItem.typeLabel,
                                            }}
                                            isListItemCard={isResponsive}
                                        />
                                    ))
                                }
                            </Box>
                        </Box>
                    </Hidden>
                </Box>
            }
        </ProgramsProvider>
        
    );
};

ProgramCarousel.defaultProps = {
    lazyLoading: false,
    disableTitleAction: false,
    viewCourseDetails: false,
};

const mapStateToProps = (reducers) => reducers.userReducer;

export default React.memo(connect(mapStateToProps, {})(ProgramCarousel), (prevProps, nextProps) => prevProps.show === nextProps.show) ;

